import { getRegionTagType } from '../facets/region-tag-labels';

/**
 * The Finnish admin1 region tag (maakunta, e.g. "830709" Uusimaa) among a job's regionTags, which
 * is what every Plus lookup is cut by. Null for jobs without one (remote, abroad). A job lists at
 * most one in practice; the first found wins.
 */
export function pickAdmin1Region(regionTags: readonly string[] | null | undefined): string | null {
  if (!regionTags) return null;
  for (const tag of regionTags) if (getRegionTagType(tag) === 'admin1') return tag;
  return null;
}
